import { render } from "./MyProspects.vue?vue&type=template&id=62d2a7bb"
import script from "./MyProspects.vue?vue&type=script&lang=ts"
export * from "./MyProspects.vue?vue&type=script&lang=ts"
script.render = render

export default script